import FeatureGates, { FeatureGateEnvironment } from '@atlassian/feature-gate-js-client';

import { Deferrable } from '@canvas/deferrable';

import { FeatureFlagSource } from '../featureFlags';

import { currentFeatureFlagState, FeatureFlagClient } from './manager';

const getEnvironment = (buildMode: 'stg-east' | 'prod-east') => {
  switch (buildMode) {
    case 'stg-east': {
      return FeatureGateEnvironment.Staging;
    }
    case 'prod-east': {
      return FeatureGateEnvironment.Production;
    }
    // development
    default: {
      return FeatureGateEnvironment.Development;
    }
  }
};

// source: https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
const getApiKey = (buildMode: 'stg-east' | 'prod-east') => {
  switch (buildMode) {
    case 'stg-east': {
      return 'ef3af703-918f-4760-96c7-ecf6877b3786';
    }
    case 'prod-east': {
      return '27e977ec-88f6-4d83-9096-7ebbd4c61c4e';
    }
    // development
    default: {
      return '2c6c9143-24ba-49c5-8158-601bd101396e';
    }
  }
};

export class StatsigClient implements FeatureFlagClient {
  constructor(
    buildMode: 'stg-east' | 'prod-east',
    tenantId: undefined | string,
    accountId: undefined | string
  ) {
    this.params = {
      buildMode,
      tenantId,
      accountId,
    };
  }

  params: {
    buildMode: 'stg-east' | 'prod-east';
    tenantId: undefined | string;
    accountId: undefined | string;
  };

  initialized = new Deferrable<string>();
  name = 'Statsig';
  status: 'initialized' | 'errored' | 'new' = 'new';

  // eslint-disable-next-line require-await
  initialize = async () => {
    await FeatureGates.initialize(
      {
        apiKey: getApiKey(this.params.buildMode),
        environment: getEnvironment(this.params.buildMode),
        targetApp: 'cc-databases_web',
        useGatewayURL: true,
        fetchTimeoutMs: 5000,
      },
      {
        atlassianAccountId: this.params.accountId,
        tenantId: this.params.tenantId,
      }
    );

    // set the initial state of the feature flags
    Object.entries(currentFeatureFlagState).forEach(([property, featureFlag]) => {
      const key = property as keyof typeof currentFeatureFlagState;
      if (featureFlag.source === FeatureFlagSource.Statsig) {
        currentFeatureFlagState[key].enabled = FeatureGates.checkGate(featureFlag.flag);
      }
    });
  };
}
